var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import throttle from 'lodash.throttle';
var withWindowSize = function withWindowSize(WrappedComponent) {
  var getDisplayName = function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  };
  var WithWindowSize = function (_Component) {
    _inherits(WithWindowSize, _Component);
    function WithWindowSize(props) {
      _classCallCheck(this, WithWindowSize);
      var _this = _possibleConstructorReturn(this, _Component.call(this, props));
      _this.onResize = throttle(_this.updateState.bind(_this), 250);
      _this.state = {
        width: window.innerWidth,
        height: window.innerHeight,
        documentWidth: document.documentElement.offsetWidth,
        documentHeight: document.documentElement.offsetHeight,
        componentWidth: undefined,
        componentHeight: undefined
      };
      return _this;
    }
    WithWindowSize.prototype.componentDidMount = function componentDidMount() {
      window.addEventListener('resize', this.onResize);
      this.componentDomNode = ReactDOM.findDOMNode(this);
      this.updateState();
    };
    WithWindowSize.prototype.componentWillUnmount = function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    };
    WithWindowSize.prototype.updateState = function updateState() {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight,
        documentWidth: document.documentElement.offsetWidth,
        documentHeight: document.documentElement.offsetHeight,
        componentWidth: this.componentDomNode.offsetWidth,
        componentHeight: this.componentDomNode.offsetHeight
      });
    };
    WithWindowSize.prototype.render = function render() {
      var _props = this.props,
        forwardedRef = _props.forwardedRef,
        otherProps = _objectWithoutProperties(_props, ['forwardedRef']);
      var _state = this.state,
        width = _state.width,
        height = _state.height,
        componentWidth = _state.componentWidth,
        componentHeight = _state.componentHeight,
        documentWidth = _state.documentWidth,
        documentHeight = _state.documentHeight;
      return React.createElement(WrappedComponent, _extends({
        windowWidth: width,
        windowHeight: height,
        documentWidth: documentWidth,
        documentHeight: documentHeight,
        componentWidth: componentWidth,
        componentHeight: componentHeight,
        ref: forwardedRef
      }, otherProps));
    };
    return WithWindowSize;
  }(Component);
  var forwardRef = function forwardRef(props, ref) {
    return React.createElement(WithWindowSize, _extends({}, props, {
      forwardedRef: ref
    }));
  };
  forwardRef.displayName = 'WithWindowSize(' + getDisplayName(WrappedComponent) + ')';
  return React.forwardRef(forwardRef);
};
export { withWindowSize };